import { UserDatacenterView } from '../../../models/datacenter-aggrid-view';
import { TranslationService } from '../../../services/translation.service';
import {
	NAMESPACE_RTPC_FIELD,
	ProductCharacteristicsTranslationService
} from '../../../services/product-characteristics-translation.services';
import {
	CommonColDef, DimensionColDef, DateColDef
} from '../../column-defs';
import { CheckboxHeaderComponent } from '../../header-components/checkbox-header.component';
import { EOfferProductData } from '../../../models/product';
import { ColumnType } from '../../column-type';

export class ProductListQuantityColumnDefinition {
	readonly emptyRow: string;
	readonly PRODUCT_LIST_REQUIRED_FIELDS = ['customerMaterialNumber'];
	// eslint-disable-next-line @typescript-eslint/naming-convention
	PRODUCT_LIST_DEFAULT_CONFIGURATION: () => Map<string, CommonColDef<EOfferProductData>
	| CommonColDef<EOfferProductData, string>>;

	constructor(
		private readonly translationService: TranslationService,
		readonly productCharacteristicsTranslationService: ProductCharacteristicsTranslationService,
		private readonly nameSpace?: string
	) {
		if (this.nameSpace === undefined) {
			this.nameSpace = NAMESPACE_RTPC_FIELD;
		}
		this.emptyRow = this.translationService.getTR('eorder.product.empty.row');
		this.PRODUCT_LIST_DEFAULT_CONFIGURATION = () =>
			new Map<string, CommonColDef<EOfferProductData> | CommonColDef<EOfferProductData, string>>([
				[
					'customerMaterialNumber',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }usePartReference`),
						sortable: false,
						valueGetter: params => params.data?.usePartReference
							? this.productCharacteristicsTranslationService.translate(params.data.usePartReference)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'customerMaterialNumber',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'steelGrade',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }steelGrade`),
						sortable: false,
						valueGetter: params => params.data?.steelGrade
							? this.productCharacteristicsTranslationService.translate(params.data.steelGrade)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'steelGrade',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'metallicCoating',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }metallicCoating`),
						sortable: false,
						valueGetter: params => params.data?.metallicCoating
							? this.productCharacteristicsTranslationService.translate(params.data.metallicCoating)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'metallicCoating',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'dimension',
					new DimensionColDef<EOfferProductData>({
						headerName: `${ this.translationService.getTR('eorder.product.dimension') } (mm)`,
						dimensionGetter(params) {
							return {
								width: params.data?.widthValue ?? 0,
								thickness: params.data?.thicknessValue ?? 0,
								length: params.data?.lengthValue ?? 0
							};
						},
						fields: ['thicknessValue', 'widthValue', 'lengthValue'],
						colId: 'dimension',
						sortable: false,
						headerComponent: CheckboxHeaderComponent,
						suppressHeaderMenuButton: false,
						width: 200,
						columnType: ColumnType.DIMENSION_COLUMN
					})
				],
				[
					'thicknessValue',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }thicknessValue`),
						sortable: false,
						valueGetter: params => params.data ? params.data.thicknessValue : '',
						suppressHeaderMenuButton: false,
						colId: 'thicknessValue',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'widthValue',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }widthValue`),
						sortable: false,
						valueGetter: params => params.data ? params.data.widthValue : '',
						suppressHeaderMenuButton: false,
						colId: 'widthValue',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'lengthValue',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }lengthValue`),
						sortable: false,
						valueGetter: params => params.data ? params.data.lengthValue : '',
						suppressHeaderMenuButton: false,
						colId: 'lengthValue',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'surfaceAspect',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }surfaceAspect`),
						sortable: false,
						valueGetter: params => params.data?.surfaceAspect
							? this.productCharacteristicsTranslationService.translate(params.data.surfaceAspect)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'surfaceAspect',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'organicDatasheetNameTop',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }organicDatasheetNameTop`),
						sortable: false,
						valueGetter: params => params.data?.organicDatasheetNameTop
							? this.productCharacteristicsTranslationService
								.translate(params.data.organicDatasheetNameTop) : '',
						suppressHeaderMenuButton: false,
						colId: 'organicDatasheetNameTop',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'colourTop',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }colourTop`),
						sortable: false,
						valueGetter: params => params.data?.colourTop
							? this.productCharacteristicsTranslationService.translate(params.data.colourTop)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'colourTop',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'strippableFilmType',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }strippableFilmType`),
						sortable: false,
						valueGetter: params => params.data?.strippableFilmType
							? this.productCharacteristicsTranslationService.translate(params.data.strippableFilmType)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'strippableFilmType',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'organicDatasheetNameBottom',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }organicDatasheetNameBottom`),
						sortable: false,
						valueGetter: params => params.data?.organicDatasheetNameBottom
							? this.productCharacteristicsTranslationService
								.translate(params.data.organicDatasheetNameBottom) : '',
						suppressHeaderMenuButton: false,
						colId: 'organicDatasheetNameBottom',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'colourBottom',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }colourBottom`),
						sortable: false,
						valueGetter: params => params.data?.colourBottom
							? this.productCharacteristicsTranslationService.translate(params.data.colourBottom)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'colourBottom',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'chemicalTreatment',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }chemicalTreatment`),
						sortable: false,
						valueGetter: params => params.data?.chemicalTreatment
							? this.productCharacteristicsTranslationService.translate(params.data.chemicalTreatment)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'chemicalTreatment',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'edgeTrimmedInLastTool',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }edgeTrimmedInLastTool`),
						sortable: false,
						valueGetter: params => params.data?.edgeTrimmedInLastTool
							? this.productCharacteristicsTranslationService.translate(params.data.edgeTrimmedInLastTool)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'edgeTrimmedInLastTool',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'floorPlatesPattern',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }floorPlatesPattern`),
						sortable: false,
						valueGetter: params => params.data
							? `${ params.data.floorPlatesPattern ?? '' } ${ params.data.floorPlatesPatternSide ?? '' }`
							: '',
						suppressHeaderMenuButton: false,
						colId: 'floorPlatesPattern',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'roughness',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }roughness`),
						sortable: false,
						valueGetter: params => params.data?.roughness
							? this.productCharacteristicsTranslationService.translate(params.data.roughness)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'roughness',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'thicknessTolerance',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }thicknessTolerance`),
						sortable: false,
						valueGetter: params => params.data?.thicknessTolerance
							? this.productCharacteristicsTranslationService.translate(params.data.thicknessTolerance)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'thicknessTolerance',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'thicknessToleranceMinus',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }thicknessToleranceMinus`),
						sortable: false,
						valueGetter: params => params.data ? params.data.thicknessToleranceMinus : '',
						suppressHeaderMenuButton: false,
						colId: 'thicknessToleranceMinus',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'thicknessTolerancePlus',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }thicknessTolerancePlus`),
						sortable: false,
						valueGetter: params => params.data ? params.data.thicknessTolerancePlus : '',
						suppressHeaderMenuButton: false,
						colId: 'thicknessTolerancePlus',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'varnishTop',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }varnishTop`),
						sortable: false,
						valueGetter: params => params.data?.varnishTop
							? this.productCharacteristicsTranslationService.translate(params.data.varnishTop)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'varnishTop',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'varnishBottom',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }varnishBottom`),
						sortable: false,
						valueGetter: params => params.data?.varnishBottom
							? this.productCharacteristicsTranslationService.translate(params.data.varnishBottom)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'varnishBottom',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'primerTop',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }primerTop`),
						sortable: false,
						valueGetter: params => params.data?.primerTop
							? this.productCharacteristicsTranslationService.translate(params.data.primerTop)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'primerTop',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'primerBottom',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }primerBottom`),
						sortable: false,
						valueGetter: params => params.data?.primerBottom
							? this.productCharacteristicsTranslationService.translate(params.data.primerBottom)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'primerBottom',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'thinOCTop',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }thinOCTop`),
						sortable: false,
						valueGetter: params => params.data?.thinOCTop
							? this.productCharacteristicsTranslationService.translate(params.data.thinOCTop)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'thinOCTop',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'thinOCBottom',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }thinOCBottom`),
						sortable: false,
						valueGetter: params => params.data?.thinOCBottom
							? this.productCharacteristicsTranslationService.translate(params.data.thinOCBottom)
							: '',
						suppressHeaderMenuButton: false,
						colId: 'thinOCBottom',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'nominalThicknessValueBottom',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }nominalThicknessValueBottom`),
						sortable: false,
						valueGetter: params => params.data ? params.data.nominalThicknessValueBottom : '',
						suppressHeaderMenuButton: false,
						colId: 'nominalThicknessValueBottom',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'nominalThicknessValueTop',
					new CommonColDef<EOfferProductData>({
						headerName: this.productCharacteristicsTranslationService
							.translate(`${ this.nameSpace }nominalThicknessValueTop`),
						sortable: false,
						valueGetter: params => params.data ? params.data.nominalThicknessValueTop : '',
						suppressHeaderMenuButton: false,
						colId: 'nominalThicknessValueTop',
						columnType: ColumnType.TEXT_COLUMN
					})
				],
				[
					'lastUsed',
					new DateColDef<EOfferProductData>({
						headerName: this.translationService.getTR('eorder.product.lastused'),
						sortable: false,
						colId: 'lastUsed',
						field: 'lastUsed',
						minWidth: 120,
						maxWidth: 120,
						width: 120,
						cellRendererParams: { inputFormat: 'isoDate', outputFormat: 'date' },
						headerComponent: CheckboxHeaderComponent,
						valueGetter: params => params.data?.lastUsed || '',
						suppressHeaderMenuButton: false,
						resizable: true,
						columnType: ColumnType.DATE_COLUMN
					}),
				]
			]);
	}
}

export const DEFAULT_VIEW_PRODUCT_LIST: UserDatacenterView = {
	columnState: [
		{
			colId: 'customerMaterialNumber',
		},
		{
			colId: 'steelGrade',
		},
		{
			colId: 'metallicCoating',
		},
		{
			colId: 'dimension',
		},
		{
			colId: 'surfaceAspect',
		},
		{
			colId: 'lastUsed',
		}
	],
	type: 'product-list',
	isDefault: true,
	name: 'Default',
	id: -99
};

export const ORGANIC_COATED_VIEW_PRODUCT_LIST: UserDatacenterView = {
	columnState: [
		{
			colId: 'customerMaterialNumber',
		},
		{
			colId: 'steelGrade',
		},
		{
			colId: 'dimension',
		},
		{
			colId: 'organicDatasheetNameTop',
		},
		{
			colId: 'colourTop',
		},
		{
			colId: 'strippableFilmType',
		},
		{
			colId: 'organicDatasheetNameBottom',
		},
		{
			colId: 'colourBottom',
		},
		{
			colId: 'lastUsed',
		}
	],
	type: 'product-list',
	isDefault: true,
	name: 'Default',
	id: -99
};
